/**
 * Builds public URLs for catalog uploads.
 *
 * Backend uploads land in S3 and are served through `/uploads/file?key=…`.
 * Some legacy values are full http URLs already; data: URLs are passed
 * through verbatim. The API key (if present) is appended so the server
 * accepts the request via the scraper-bypass query param.
 */

const API_BASE = process.env.REACT_APP_API_BASE || "/v1";
const API_KEY = process.env.REACT_APP_API_KEY;

function appendApiKey(url) {
  if (!API_KEY || url.includes("api_key=")) return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}api_key=${encodeURIComponent(API_KEY)}`;
}

export function buildPhotoUrl(value) {
  if (!value) return "";
  if (/^data:/i.test(value)) return value;
  if (/^https?:\/\//i.test(value)) return appendApiKey(value);
  return appendApiKey(
    `${API_BASE}/uploads/file?key=${encodeURIComponent(value)}`,
  );
}

export function getUploadFileUrl(key) {
  return appendApiKey(
    `${API_BASE}/uploads/file?key=${encodeURIComponent(key)}`,
  );
}
